import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import EventChecklistService from './EventChecklistService';
import { CATEGORY_PRE_TEST, CATEGORY_POST_TEST } from 'shared/constants';

// Actions
const GET_PRE_EVENT_TASKS = 'eventChecklist/GET_PRE_EVENT_TASKS';
const GET_POST_EVENT_TASKS = 'eventChecklist/GET_POST_EVENT_TASKS';
const UPDATE_TASK = 'eventChecklist/UPDATE_TASK';
const CLEAR_ERROR = 'eventChecklist/CLEAR_ERROR';

const initialState = {
  eventTasks: {
    pre: [],
    post: [],
  },
  loadingEventTasks: false,
  loadingUpdateTask: false,
  errorUpdate: {},
};

// Reducer
export default function eventChecklistReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PRE_EVENT_TASKS:
      return {
        ...state,
        eventTasks: {
          ...state.eventTasks,
          pre: action.result.data || [],
        },
        loadingEventTasks: action.result.loading,
        errorUpdate: {},
      };
    case GET_POST_EVENT_TASKS:
      return {
        ...state,
        eventTasks: {
          ...state.eventTasks,
          post: action.result.data || [],
        },
        loadingEventTasks: action.result.loading,
        errorUpdate: {},
      };
    case UPDATE_TASK:
      return {
        ...state,
        task: action.result.data || {},
        errorUpdate: action.result.error,
        loadingUpdateTask: action.result.loading,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        errorUpdate: {},
      };
    default:
      return state;
  }
}

// Action Creators

export function getPreEventTasksAction(result) {
  return { type: GET_PRE_EVENT_TASKS, result };
}

export function getPostEventTasksAction(result) {
  return { type: GET_POST_EVENT_TASKS, result };
}

export function updateTaskAction(result) {
  return { type: UPDATE_TASK, result };
}

export function clearErrorAction() {
  return { type: CLEAR_ERROR, result: {} };
}

// Action dispatcher functions

export function getEventTasks(id, params) {
  const getEventTaskAction =
    params.category === CATEGORY_PRE_TEST ? getPreEventTasksAction : getPostEventTasksAction;
  return createDispatchFunction(
    partial(EventChecklistService.getEventTasks, id, params),
    getEventTaskAction
  );
}

export function updateTask(eventId, data) {
  return createDispatchFunction(
    partial(EventChecklistService.updateTask, eventId, data),
    updateTaskAction
  );
}

